import { StudyLesson, StudyPlanTopic } from '@lf/ui-primitives';
// The marketing homepage runs from `learnforest.app`; the import
// CTAs hand the visitor off to the live student / parent apps where
// the existing /share/<token> landing handles auth, COPPA, and import.
// Hosts can be overridden at build time via REACT_APP_LF_CHILD_APP_URL /
// REACT_APP_LF_PARENT_APP_URL for staging / e2e setups; otherwise we
// hardcode prod so the static homepage doesn't need runtime config.
const STUDENT_APP_BASE =
    process.env.REACT_APP_LF_CHILD_APP_URL || "https://student.learnforest.app";
const PARENT_APP_BASE =
    process.env.REACT_APP_LF_PARENT_APP_URL || "https://parent.learnforest.app";

function StudyPlanDetailsModal({ studyPlan }) {
    const studentShareUrl = studyPlan.share_token
        ? `${STUDENT_APP_BASE.replace(/\/$/, "")}/share/${studyPlan.share_token}`
        : null;
    const parentShareUrl = studyPlan.share_token
        ? `${PARENT_APP_BASE.replace(/\/$/, "")}/share/${studyPlan.share_token}`
        : null;

    return (
        <div
            id={`${studyPlan.subject}-details`}
            data-iv1-modal-root={studyPlan.subject}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 hidden"
        >
            <div className="bg-white p-6 sm:p-12 rounded-lg shadow-lg w-9/10 md:w-2/3 h-4/5 relative">
                <button
                    id={`${studyPlan.subject}-details-close-button`}
                    type="button"
                    data-iv1-modal-close={studyPlan.subject}
                    className="absolute top-4 right-6 text-gray-500 hover:text-gray-800 text-2xl"
                >
                    x
                </button>
                <div className="text-left h-full w-full flex flex-col">
                    <div className="overflow-y-auto flex-grow">
                        <h3 className="text-2xl font-semibold">{studyPlan.image} {studyPlan.title || studyPlan.subject}</h3>
                        <div className="text-lg">{studyPlan.description}</div>
                        <div className="flex justify-end mb-4">
                            <button
                                id={`${studyPlan.subject}-details-more-button`}
                                type="button"
                                data-iv1-modal-toggle-topics={studyPlan.subject}
                                className="bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 py-2 px-3 rounded text-sm"
                            >
                                Show Details
                            </button>
                        </div>
                        {studyPlan.lessons.map((lesson, index) => (
                            <div key={lesson.title}>
                                <StudyLesson lesson={lesson} index={index} isLastLesson={index === studyPlan.lessons.length - 1} onLessonClick={() => { }}>
                                    <div className={`${studyPlan.subject}-topics`} style={{ display: 'none' }}>
                                        {lesson.topics.map((topic, topicIndex) => (
                                            <StudyPlanTopic topic={topic} index={topicIndex} />
                                        ))}
                                    </div>
                                </StudyLesson>
                            </div>
                        ))}
                    </div>
                    {studyPlan.share_token ? (
                        <div
                            data-testid={`${studyPlan.subject}-import-cta-row`}
                            className="mt-8 flex flex-col sm:flex-row gap-3 justify-center"
                        >
                            <a
                                href={studentShareUrl}
                                data-ga-cta="student_import"
                                data-ga-plan={studyPlan.subject}
                                className="bg-primary-600 hover:bg-primary-700 text-white font-semibold px-6 py-3 rounded-xl text-base transition-colors text-center"
                            >
                                Import using student app
                            </a>
                            <a
                                href={parentShareUrl}
                                data-ga-cta="parent_import"
                                data-ga-plan={studyPlan.subject}
                                className="border-2 border-darkrock/50 hover:border-darkrock text-darkrock font-semibold px-6 py-3 rounded-xl text-base transition-colors text-center"
                            >
                                Import using parent app
                            </a>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export default StudyPlanDetailsModal;
